<mat-dialog-content>
  <section class="quotation-rejection-wrapper">
    <h2 class="cmn-popup-title">Approve {{dlp ? 'DLP' : 'Quotation'}}</h2>
    <button class="cmn-close" mat-dialog-close></button>
    <p>Are you sure?</p>
    <div class="flex-btn-wrapper">
      <button class="cmn-reject-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-reject-btn" type="button" *ngIf="!dlp" (click)="onApprove()">
        Approve
      </button>
    </div>
  </section>
</mat-dialog-content>
